export const getTailoringCollectionList = state => {
    return state.list
}

export const getTailoringCollectionDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/tailoringCollection/getters.js